// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"582":"6a5361f9","838":"9f8f00f2"}[chunkId] + ".chunk.js";
};